import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import Checkbox from "@visa/vds/checkbox";
import CheckboxList from "@visa/vds/checkbox-list";
import CheckboxListItem from "@visa/vds/checkbox-list-item";
import Col from "@visa/vds/col";
import Grid from "@visa/vds/grid";
import Link from '@visa/vds/link';
import Row from "@visa/vds/row";
import Typography from "@visa/vds/typography";
import {
    CONFIRM_PLACE_ORDER,
    SUBSCRIPTION_DETAILS_STAGE,
} from "_constants/GlobalConstants";
import { TERMS_OF_USE, VSTS_FEE_WAIVER_TERMS, VSTT_FEE_WAIVER_TERMS } from "_constants/PageRoutes";
import { UserRole } from "_constants/UserRole";
import MCSOverlayLoading from "components/MCSOverlayLoading";
import MCSSpace from "components/MCSSpace";
import OrderOrganizationDetails from "components/order/OrderOrganizationDetails";
import { useAuthContext, useAuthContextUser, useSetAuthContextUser } from "context/AuthContext";
import { GlobalAlertContext } from "context/GlobalAlertContext";
import TermsOfUseHistoryDialog from "pages/TermsOfUse/Components/TermsOfUseHistoryDialog";
import React, { useContext, useEffect, useState } from "react";
import { userService } from "services/user.service";
import VSTSOrderReview from "./Components/Review/VSTSOrderReview";
import VSTTOrderReview from "./Components/Review/VSTTOrderReview";
import { ProductSelectionConst } from "./Components/SelectProduct/ProductSelectionLogic";
import "./Style/Store.css";
import { StoreApi } from "services/store.service";

const Review = (props) => {
    let {
        selectedCategory,
        // VSTS
        selectedVSTSSubscriptionInfoId, selectedVSTSStartDate, selectedVSTSEndDate,
        selectedVSTSProductInfoDetails, setVSTSSelectedProductInfoDetails,

        // VSTT
        selectedVSTTProductInfoDetails, setVSTTSelectedProductInfoDetails,
        totalVSTTSetupFee, setTotalVSTTSetupFee,
        totalVSTTMonthlyFee, setTotalVSTTMonthlyFee,
        totalVSTTYearlyFee, setTotalVSTTYearlyFee,

        // Fee Waiver
        feeWaiverOptions, selectedFeeWaiverId,

        // Order confirmation (after order is created)
        setOrderConfirmation,

        handleStepUpdate
    } = props;
    const alertContext = useContext(GlobalAlertContext);
    const user = useAuthContextUser();
    const context = useAuthContext();
    const setUser = useSetAuthContextUser();

    const [userOrganization, setUserOrganization] = useState(null);
    const [isFetchingData, setIsFetchingData] = useState(true);
    const [agreedBillingAndTou, setAgreedBillingAndTou] = useState(false);
    // const [confirmedOrganizationBilling, setConfirmedOrganizationBilling] = useState(false);
    // const [agreedTou, setAgreedTou] = useState(false);
    const [selectedFeeWaiver, setSelectedFeeWaiver] = useState(null);
    const [agreedFeeWaiverTerms, setAgreedFeeWaiverTerms] = useState(false);
    const [confirmBtnDisabled, setConfirmBtnDisabled] = useState(true);
    const [isTouHistoryDialogDisplay, setIsTouHistoryDialogDisplay] = useState(false)

    const fetchVSTSProductSubscriptionPrice = async () => {
        const ProductPriceMapping = await StoreApi.GetVstsSubscriptionPricing(
            selectedVSTSSubscriptionInfoId
        );
        setVSTSSelectedProductInfoDetails(ProductPriceMapping);
    };

    const fetchOrganizationInform = async () => {
        // console.log('fetchOrganizationInform - user: ', user);
        const response = await userService.GetOrganization(
            user.organizationId
        );
        setUserOrganization(response);
    };

    const openTou = async (e) => {
        // console.log('openTou - user: ', user.entitleId);
        e.preventDefault(); // to disable onChange for ToU checkbox
        if (user.entitleId === UserRole.UserExternal_Entitlement) {
            window.open(TERMS_OF_USE, "_blank");
        } else {
            setIsTouHistoryDialogDisplay(true);
        }
    };
    const openFeeWaiverTerms = async (e) => {
        e.preventDefault(); // to disable onChange for FeeWaiver checkbox
        if (selectedCategory === ProductSelectionConst.VSTS_CATEGORY) {
            window.open(VSTS_FEE_WAIVER_TERMS, "_blank");
        } else {
            window.open(VSTT_FEE_WAIVER_TERMS, "_blank");
        }
    };

    //This is so that orders are not double added into the list
    const ResetOrders = async () => {
        if (selectedCategory === ProductSelectionConst.VSTT_CATEGORY) {
            setVSTTSelectedProductInfoDetails([]);
        }
        handleStepUpdate(SUBSCRIPTION_DETAILS_STAGE)
    };

    const toggleAgreedBillingAndTou = () => {
        setAgreedBillingAndTou(!agreedBillingAndTou);
        toggleConfirmBtnDisabled(!agreedBillingAndTou, agreedFeeWaiverTerms);
    }

    const toggleConfirmBtnDisabled = (billingAndTou, fwt) => {
        setConfirmBtnDisabled(!billingAndTou || (selectedFeeWaiverId > 0 && !fwt));
    };

    const toggleAgreedFeeWaiverTerms = (e) => {
        // console.log("on Fw checkbox toggled!", e);
        setAgreedFeeWaiverTerms(!agreedFeeWaiverTerms);
        toggleConfirmBtnDisabled(agreedBillingAndTou, !agreedFeeWaiverTerms);
    };

    const PlaceOrder = async () => {
        if (user.is3DSStoreViewable) {
            alertContext.setErrorMessage("Only Subscription Managers can place order.");
            return;
        }

        var orderList; // an array of StorePlaceOrderDto
        if (selectedCategory === ProductSelectionConst.VSTS_CATEGORY) {
            // TODO: Should create a copy of selectedVSTSProductInfoDetails.
            // Reduce properties sent to API
            orderList = [selectedVSTSProductInfoDetails];
        } else if (selectedCategory === ProductSelectionConst.VSTT_CATEGORY) {
            // TODO: Should create a copy of selectedVSTTProductInfoDetails.
            // Reduce properties sent to API
            orderList = selectedVSTTProductInfoDetails;
        } else {
            alertContext.setErrorMessage("Failed to create the Order - incorrect order information");
            return;
        }

        if (selectedFeeWaiverId > 0) {
            updateFeeWaiverToOrderList(selectedFeeWaiver, orderList);
        }

        setIsFetchingData(true);
        const order = await StoreApi.PlaceOrder(
            {
                subscriptionOrders: orderList,
                productCategory: selectedCategory
            }
        );

        if (order == null) {
            alertContext.setErrorMessage("Failed to create the Order - Incorrect order confirmation response");
        } else if (!order.orderSuccess) {
            alertContext.setErrorMessage(order.errorMessage);
        } else if (order.orderSuccess) {
            if (order.hasVstsAccess && selectedCategory === ProductSelectionConst.VSTS_CATEGORY) {
                context.user.navigation.vstsAccess = true;
                setUser(context);
            }
            setOrderConfirmation(order);
            alertContext.setSuccessMessage("Order placed successfully!");
            handleStepUpdate(CONFIRM_PLACE_ORDER);
        }

        setIsFetchingData(false);
    };

    useEffect(() => {
        setIsFetchingData(true);
        fetchOrganizationInform();

        if (selectedCategory === ProductSelectionConst.VSTS_CATEGORY) {
            fetchVSTSProductSubscriptionPrice();
        }

        if (feeWaiverOptions && selectedFeeWaiverId && selectedFeeWaiverId) {
            const _selectedFeeWaiver = feeWaiverOptions.find(x => x.productId === selectedFeeWaiverId);
            setSelectedFeeWaiver(_selectedFeeWaiver);
        }

        setIsFetchingData(false);
    }, []);

    /** Fee Waiver or Fee Discount START */
    const updateFeeWaiverToOrderList = (selectedFeeWaiver, orderList) => {
        const ordersWithFeeWaivers = orderList.filter(order =>
            order.productId === selectedFeeWaiver.productId
        );
        ordersWithFeeWaivers.forEach(order => {
            // For monthly subscription
            // order.feeWaiverId is populated just before it is sent to API
            if (order.productCategoryId === ProductSelectionConst.VSTS_CATEGORY || order.recurringIntervalType === ProductSelectionConst.MONTHLY_SUBSCRIPTION_INTERVAL) {
                order.feeWaiverId = selectedFeeWaiver.id;
            }
            // For set up fee
            // order.setUpSubscription.feeWaiverId is populated just before it is sent to API
            if (order.hasSetUp) {
                order.setUpSubscription.feeWaiverId = selectedFeeWaiver.id;
            }
        })
    }
    /** Fee Waiver or Fee Discount END */

    return (
        <>
            {isFetchingData && <MCSOverlayLoading />}
            <MCSSpace height="30px" />
            <Grid>
                <Row>
                    <Col lg={4}>
                        <OrderOrganizationDetails
                            displaySubscriptionManager={true}
                            licensedBusinessPaymentInformation={userOrganization && userOrganization.organizationLicensedBusiness}
                            paymentModeName={userOrganization && userOrganization.paymentModeName}
                        />
                    </Col>
                </Row>
                {selectedCategory === ProductSelectionConst.VSTS_CATEGORY && (
                    <VSTSOrderReview
                        order={selectedVSTSProductInfoDetails}
                        selectedProductInfoId={selectedVSTSSubscriptionInfoId}
                        selectedVSTSStartDate={selectedVSTSStartDate}
                        selectedVSTSEndDate={selectedVSTSEndDate}
                        selectedFeeWaiver={selectedFeeWaiver}
                    />
                )}

                {selectedCategory === ProductSelectionConst.VSTT_CATEGORY && (
                    <VSTTOrderReview
                        order={selectedVSTTProductInfoDetails}
                        totalVSTTSetupFee={totalVSTTSetupFee} setTotalVSTTSetupFee={setTotalVSTTSetupFee}
                        totalVSTTMonthlyFee={totalVSTTMonthlyFee} setTotalVSTTMonthlyFee={setTotalVSTTMonthlyFee}
                        totalVSTTYearlyFee={totalVSTTYearlyFee} setTotalVSTTYearlyFee={setTotalVSTTYearlyFee}
                        selectedFeeWaiver={selectedFeeWaiver}
                    />
                )}
                <Row>
                    <Col>
                        <CheckboxList>
                            <CheckboxListItem>
                                <Checkbox
                                    id="confirm-TOU-payment-checkbox"
                                    checked={agreedBillingAndTou}
                                    name="terms-of-use-agreement"
                                    label={<Typography tag="span">
                                        I confirm that the Payment Mode, Billing Organization and BID are correct and will be used for Subscription Billing. I have read and agree on behalf of the Billing Organization shown above to the <Link inline onClick={(e) => { openTou(e) }}>Terms of Use</Link>.
                                    </Typography>}
                                    onChange={toggleAgreedBillingAndTou}
                                    required
                                />
                                {selectedFeeWaiverId > 0 &&
                                    <Checkbox
                                        checked={agreedFeeWaiverTerms}
                                        name="fee-waiver-agreement"
                                        label={<Typography tag="span">
                                            I have read and agreed to the <Link inline onClick={(e) => { openFeeWaiverTerms(e) }}>Fee Waiver / Fee Discount Terms</Link>.
                                        </Typography>}
                                        onChange={toggleAgreedFeeWaiverTerms}
                                        required
                                        id="fee-waiver-agreement-checkbox"
                                    />
                                }
                            </CheckboxListItem>
                        </CheckboxList>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ButtonGroup direction="right">
                            <ButtonText
                                colorScheme="secondary"
                                onClick={() => ResetOrders()}
                            >
                                Back
                            </ButtonText>
                            <ButtonText disabled={confirmBtnDisabled} onClick={() => PlaceOrder()}>Place Order</ButtonText>
                        </ButtonGroup>
                    </Col>
                </Row>
            </Grid>
            {user.entitleId !== UserRole.UserExternal_Entitlement &&
                <TermsOfUseHistoryDialog isDisplay={isTouHistoryDialogDisplay} setIsDisplay={setIsTouHistoryDialogDisplay} />
            }
        </>
    );
};

export default Review;
